import { FunctionComponent } from 'react';

import RewindGlobe, { RewindGlobeProps } from '@/components/RewindGlobe';

const Countries: FunctionComponent<RewindGlobeProps> = (props) => {
  const { consumptionPerCountry } = props;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <div className="m-auto">
        <h2 className="text-xl xs:text-2xl sm:text-3xl lg:text-4xl slide-up mb-8 lg:mb-0">
          Your viewing spanned
          {' '}
          <span className="text-dark-tangerine">
            {`${Object.keys(consumptionPerCountry).length}`}
            {' '}
            {Object.keys(consumptionPerCountry).length > 1 ? 'countries' : 'country'}
          </span>
        </h2>
      </div>
      <div
        className="m-auto slide-in-from-right"
      >
        <RewindGlobe {...props}/>
      </div>
    </div>
  );
};

export default Countries;
